/**
 * Currency Icon Registry
 * 
 * This file provides a centralized way to get currency icons.
 * Icons are imported statically but organized to allow better code splitting.
 * Webpack will tree-shake unused icons if they're not referenced elsewhere.
 */

import React from 'react'
import {
  BtcCurrencyBadge,
  LtcCurrencyBadge,
  BitcoinCashBadge,
  BinanceCoinBadge,
  DogecoingBadge,
  EthereumBadge,
  TronBadge,
  UsdtIcon,
  UsdcBadge,
  SolanaIcon,
  BusdIcon,
  MoneroIcon,
  USDIcon,
  MXNIcon,
  EURIcon,
  BRLIcon,
} from '@/assets/icons'

/**
 * Get currency icon component for a given currency ID
 * @param {string} currencyId - The currency identifier
 * @param {boolean} isDefault - Whether to use default fill color
 * @returns {React.Element|null} - The icon component or null
 */
export const getCurrencyIcon = (currencyId, isDefault = false) => {
  const fill = isDefault ? 'currentColor' : undefined

  switch (currencyId) {
    case 'BTC':
      return <BtcCurrencyBadge width="1.2em" fill={fill} />
    case 'LTC':
    case 'LTCT':
      return <LtcCurrencyBadge width="1.2em" fill={fill} />
    case 'BCH':
      return <BitcoinCashBadge width="1.2em" fill={fill} />
    case 'BNB':
      return <BinanceCoinBadge width="1.2em" fill={fill} />
    case 'DOGE':
      return <DogecoingBadge width="1.2em" fill={fill} />
    case 'ETH':
      return <EthereumBadge width="1.2em" fill={fill} />
    case 'TRX':
      return <TronBadge width="1.2em" fill={fill} />
    case 'USDT':
      return <UsdtIcon width="1.2em" fill={fill} />
    case 'USDC':
      return <UsdcBadge width="1.2em" fill={fill} />
    case 'SOL':
      return <SolanaIcon width="1.2em" fill={fill} />
    case 'BUSD':
      return <BusdIcon width="1.2em" fill={fill} fillcolor="white" />
    case 'XMR':
      return <MoneroIcon width="1.2em" fill={fill} />
    case 'USD':
      // return <USDIcon />
    case 'MXN':
      return <MXNIcon width="20px" />
    case 'EUR':
      return <EURIcon />
    case 'BRL':
      return <BRLIcon />
    default:
      return null
  }
}

